import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { RequerimientoDTO } from '../../../../core/models/titulacion/requerimiento-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class RequerimientoService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getRequerimientoService() {
        return this.http.get<BodyListResponse<RequerimientoDTO>>(
            API_URL + '/api/v1/requerimiento/todos'
        );
    }

    guardarRequerimientoService(requerimientoDTO: RequerimientoDTO) {
        return this.http.post(API_URL + '/api/v1/requerimiento', requerimientoDTO);
    }

    getRequerimientoPorCodigoRequerimientoService(codigoRequerimiento: string) {
        return this.http.get<BodyResponse<RequerimientoDTO>>(
            API_URL + '/api/v1/requerimiento/' + codigoRequerimiento
        );
    }
}
